"use client";

import { useFormStatus } from "react-dom";

/**
 * A submit button that shows its own form's pending state, for forms whose
 * action is a Server Action built in a SERVER component (the Google button on
 * /signin, "Sign out" on the invitation pages). `useFormStatus` reads only the
 * nearest enclosing <form>, so this has to be a child of that form.
 *
 * `aria-disabled` + an inert click, NOT `disabled` — same rule as
 * `InviteActions` and the password form: `disabled` drops keyboard focus to
 * <body> mid-submit. The label keeps its color; `aria-busy` and the changed
 * words carry the state, so nothing dims below AA.
 */
export function PendingSubmit({ children, pendingLabel, className, style }: {
  children: React.ReactNode;
  pendingLabel: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}) {
  const { pending } = useFormStatus();
  return (
    <button
      type="submit"
      className={className}
      aria-disabled={pending}
      aria-busy={pending}
      onClick={(e) => { if (pending) e.preventDefault(); }}
      style={{ ...style, cursor: pending ? "progress" : style?.cursor }}
    >
      {pending ? pendingLabel : children}
    </button>
  );
}
